export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_CATEGORIES_PAGINATION = 'SET_CATEGORIES_PAGINATION';
